import {
  type PropsWithChildren, useContext,
} from 'react';
import { TableContext } from '~/_shared/baseComponents/table/table.context';
import { getNoResultsRowStyles } from '~/_shared/baseComponents/table/table.styles';

type TableNoResultsRowProps = PropsWithChildren;

export const TableNoResultsRowComponent = ({ children }: TableNoResultsRowProps) => {
  const { columnCount } = useContext(TableContext);

  return (
    <div css={getNoResultsRowStyles({ columnCount })}>
      {children}
    </div>
  );
};
